(function() { module.exports = this["moment"]; }());